module.exports = __webpack_public_path__ + "img/vitara-2022.9b2ce21c.svg";